import OrderFoodListItem from '@components/order/components/common/order-food/OrderFoodListItem';
import OrderFoodRequest from '@components/order/models/edit/OrderFoodRequest';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderFoodActions from './OrderFoodActions';

interface OrderCartFoodListItemProps {
    orderFood: OrderFoodRequest;
    onEditClick: (orderFood: OrderFoodRequest) => void;
    onRemoveClick: (orderFood: OrderFoodRequest) => void;
}

const OrderCartFoodListItem: React.FC<OrderCartFoodListItemProps> = observer(({ orderFood, onEditClick, onRemoveClick }) => {
    const handleOnRemoveClick = () => {
        onRemoveClick(orderFood);
    }

    const handleOnEditClick = () => {
        onEditClick(orderFood);
    }


    return (
        <OrderFoodListItem
            orderFood={orderFood}
            actions={
                <OrderFoodActions onEditClick={handleOnEditClick} onRemoveClick={handleOnRemoveClick} />
            } />
    )
})

export default OrderCartFoodListItem;